import { API } from '../../../../../api'
import { PageList } from '../../../utils'

import { QUERY } from './queries'

const List: PageList<API.courses_index> = {
  queryKey: 'resources',
  query: QUERY,
}

export default List
